(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rabbit-hole-map"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-rh-map]');
  if (!root) return;
  const buttons = [...root.querySelectorAll('[data-cluster-button]')];
  const overview = root.querySelector('[data-all-panel]');
  const panels = [...root.querySelectorAll('[data-cluster-panel]')];
  const pins = [...root.querySelectorAll('[data-location]')];
  const cards = [...root.querySelectorAll('[data-location-card]')];
  const filters = [...root.querySelectorAll('[data-filter]')];
  let cluster = 'all';
  const values = () => Object.fromEntries(filters.map(filter => [filter.dataset.filter, filter.value]));
  const matches = (item) => {
    const active = values();
    return Object.entries(active).every(([key, value]) => !value || (`|${item.dataset[key] || ''}|`).includes(`|${value}|`));
  };
  const render = () => {
    pins.forEach(pin => pin.hidden = cluster === 'all' || pin.closest('[data-cluster-panel]').dataset.clusterPanel !== cluster || !matches(pin));
    cards.forEach(card => {
      const cardCluster = card.closest('[data-directory-cluster]')?.dataset.directoryCluster;
      card.hidden = (cluster !== 'all' && cardCluster !== cluster) || !matches(card);
    });
    root.querySelectorAll('[data-directory-cluster]').forEach(section => section.hidden = ![...section.querySelectorAll('[data-location-card]')].some(card => !card.hidden));
  };
  const selectCluster = (nextCluster) => {
    cluster = nextCluster;
    buttons.forEach(item => item.setAttribute('aria-selected', item.dataset.clusterButton === cluster ? 'true' : 'false'));
    if (overview) {
      const active = cluster === 'all';
      overview.hidden = !active;
      overview.classList.toggle('is-active', active);
    }
    panels.forEach(panel => { const active = panel.dataset.clusterPanel === cluster; panel.hidden = !active; panel.classList.toggle('is-active', active); });
    render();
  };
  buttons.forEach(button => button.addEventListener('click', () => selectCluster(button.dataset.clusterButton)));
  filters.forEach(filter => filter.addEventListener('change', render));
  root.querySelector('[data-reset-filters]')?.addEventListener('click', () => { filters.forEach(filter => filter.value = ''); selectCluster('all'); });
  pins.forEach(pin => pin.addEventListener('click', () => {
    if (pin.dataset.locationUrl) window.location.href = pin.dataset.locationUrl;
  }));
  const openCard = (card) => {
    if (card.dataset.locationUrl) {
      window.location.href = card.dataset.locationUrl;
      return;
    }
  };
  cards.forEach(card => {
    card.addEventListener('click', event => {
      if (event.target.closest('a, button, select, input, summary')) return;
      openCard(card);
    });
    card.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (event.target.closest('a, button, select, input, summary')) return;
      event.preventDefault();
      openCard(card);
    });
  });
  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rabbit-hole-society"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.rhs').forEach(root => {
  const doors = Array.from(root.querySelectorAll('[data-rhs-door]'));
  const surprise = root.querySelector('[data-rhs-surprise]');
  if (surprise) { surprise.hidden = false; surprise.addEventListener('click', () => { const door = doors[Math.floor(Math.random()*doors.length)]; if (!door) return; doors.forEach(item => { item.open = item === door; }); door.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'}); door.querySelector('summary').focus({preventScroll:true}); }); }
  const form = root.querySelector('.rhs__claim form');
  root.querySelectorAll('[data-rhs-record]').forEach(button => { if (!form) return; button.hidden = false; button.addEventListener('click', () => { const select = form.querySelector('select'); if (!select) return; select.value = button.dataset.rhsRecord; select.dispatchEvent(new Event('change',{bubbles:true})); form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'}); form.querySelector('textarea').focus({preventScroll:true}); }); });
});

  } catch(e) { console.error(e); }
})();
})();
